module.exports = __WEBPACK_EXTERNAL_MODULE_http_localhost_4201_remoteEntry_mjs_ba8924b6__;